import React, { useState } from 'react'
import { CircularProgress } from '@material-ui/core'
import { Page, Header, CustomTable } from 'components'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import VisibilityIcon from '@material-ui/icons/Visibility'

import useRouter from 'utils/useRouter'
import { DetailPanel } from './DetailPanel'
import { FiltrosBancoPericiandos } from './FiltrosBancoPericiandos'

import useStyles from './styles'

export const BancoDePericiando = (props) => {
  const { route } = props
  const router = useRouter()
  moment.locale('pt-br', localization)
  const [processandoPericiando, setProcessandoPereciando] = useState(false)
  const classes = useStyles()
  const [periciandos, setPericiandos] = useState([])

  const handleClickVisualizarPaginaPericiando = (rowData) => {
    router.history.push(`/casos/caso/periciando/detalhar/${rowData.id}`)
  }

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />
      <FiltrosBancoPericiandos setPericiandos={setPericiandos} setProcessandoPereciando={setProcessandoPereciando} />
      {processandoPericiando ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <CustomTable
          searchPlaceholder="Buscar periciandos..."
          localization={{
            body: {
              emptyDataSourceMessage: 'Nenhum periciando encontrado',
            },
          }}
          columns={[
            {
              title: 'CPF',
              render: (rowData) => rowData.cpf || 'NÃO INFORMADO',
            },
            {
              title: 'Nome',
              render: (rowData) => (rowData.nome ? rowData.nome.toUpperCase() : 'NÃO IDENTIFICADO'),
            },
            {
              title: 'Data de Entrada',
              render: (rowData) => moment(rowData.createdAt).format('LLLL'),
            },
          ]}
          detailPanel={(rowData) => <DetailPanel idPericiandoSelecionado={rowData.id} />}
          onRowClick={(event, rowData, togglePanel) => togglePanel()}
          data={periciandos}
          actions={[
            {
              icon: VisibilityIcon,
              tooltip: 'Visualizar página do periciando',
              onClick: (event, rowData) => handleClickVisualizarPaginaPericiando(rowData),
            },
          ]}
          options={{
            pageSize: 20,
          }}
        />
      )}
    </Page>
  )
}
